<template>
  <picture class="nice-logo">
    <img v-bind:style="logoStyle" src="@/assets/logo/nice-basic.png" alt="nice logo" />
  </picture>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '30px',
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logoStyle() {
      return {
        // width: this.width,
        objectFit: 'contain',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.nice-logo {
  cursor: pointer;
  line-height: 1;

  img {
    vertical-align: middle;
  }
}
</style>
